module.exports = __webpack_public_path__ + "img/faqs_cold_weather_tips_en.415e9e99.webp";